"use client";

import { cn } from "../../utils/cn";
import React, { useEffect, useState, useRef } from "react";
import { Button } from "./moving-borders";

const Tooltip = ({ text }) => {
  return (
    <div
      className={cn(
        "absolute -top-10 left-1/2 transform -translate-x-1/2 px-2 py-1 text-xs md:text-sm bg-zinc-900 text-white rounded-lg opacity-0 scale-0 transition-all duration-300 group-hover:opacity-100 group-hover:scale-100"
      )}
    >
      {text}
    </div>
  );
};

export const InfiniteStack = ({
  items,
  direction = "",
  speed = "slow",
  pauseOnHover = false,
  className,
}) => {
  const containerRef = useRef(null);
  const scrollerRef = useRef(null);

  useEffect(() => {
    addAnimation();
  }, []);

  const [start, setStart] = useState(false);

  function addAnimation() {
    if (containerRef.current && scrollerRef.current) {
      const scrollerContent = Array.from(scrollerRef.current.children);

      scrollerContent.forEach((item) => {
        const duplicatedItem = item.cloneNode(true);
        if (scrollerRef.current) {
          scrollerRef.current.appendChild(duplicatedItem);
        }
      });

      getDirection();
      getSpeed();
      setStart(true);
    }
  }

  const getDirection = () => {
    if (containerRef.current) {
      if (direction === "left") {
        containerRef.current.style.setProperty(
          "--animation-direction",
          "forwards"
        );
      } else {
        containerRef.current.style.setProperty(
          "--animation-direction",
          "reverse"
        );
      }
    }
  };

  const getSpeed = () => {
    if (containerRef.current) {
      if (speed === "fast") {
        containerRef.current.style.setProperty("--animation-duration", "150s");
      } else if (speed === "slow") {
        containerRef.current.style.setProperty("--animation-duration", "280s");
      } else {
        containerRef.current.style.setProperty("--animation-duration", "200s");
      }
    }
  };

  return (
    <div
      ref={containerRef}
      className={cn(
        // max-w-7xl to w-screen
        "scroller relative z-20 w-screen overflow-hidden  [mask-image:linear-gradient(to_right,transparent,white_20%,white_80%,transparent)]",
        className
      )}
    >
      <ul
        ref={scrollerRef}
        className={cn(
          // change gap-16
          "flex min-w-full shrink-0 gap-10 md:py-1.5 w-max flex-nowrap",
          start && "animate-scroll ",
          pauseOnHover && "hover:[animation-play-state:paused]"
        )}
      >
        {items.map((card, idx) => (
          <li key={idx} className="relative flex flex-row justify-start gap-3 items-start group">

            <Button
              key={card.id}
              duration={10000}
              borderRadius="1.75rem"
              style={{
                backgroundColor: "rgb(39 39 42)", // Zinc-800
                background:
                  "linear-gradient(90deg, rgba(39,39,42,1) 0%, rgba(24,24,27,1) 100%)", // Zinc-800 to Zinc-900
                borderRadius: `calc(1.75rem* 0.3)`,
              }}
              className="flex-1  text-black lg:rounded-md rounded-sm dark:text-white border-neutral-200 dark:border-zinc-900 hover:scale-110"
            >
              <div className="flex flex-row justify-center element items-center ">
                <div className="flex justify-center items-center p-1  md:p-1.5 lg:p-2">
                  <img
                    src={card.thumbnail}
                    alt={card.thumbnail}
                    loading="lazy"
                    className="lg:w-14 lg:h-14 h-12 w-12 "
                  />
                </div>
              </div>
            </Button>

          </li>
        ))}
      </ul>
    </div>
  );
};
